import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const Card = ({ icon, title, discription, index }) => {
  const ref = useRef();
  const isInView = useInView(ref, { amount: 0.5, once: true });

  const staggeredAnimation = {
    hidden: {
      opacity: 0,
    },
    visible: (index) => ({
      opacity: 1,
      transition: {
        delay: 0.375 * index,
        duration: 0.825,
      },
    }),
  };

  return (
    <>
      <motion.div
        ref={ref}
        variants={staggeredAnimation}
        initial={"hidden"}
        animate={isInView ? "visible" : "hidden"}
        custom={index}
        className="h-full w-full rounded-b-sm shadow-visShadow"
      >
        <div className="flex h-full items-start gap-3 px-4 py-8">
          <img className="h-8 w-8" src={icon} alt="image not found" />
          <div className="">
            <h1 className="mb-2 text-14 font-bold">{title}</h1>
            <p className="text-14 font-light text-gray-700">{discription}</p>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default Card;
